/**
 * SCRUM-128 — claim manual /display/pair?code=
 */
import { createFileRoute } from "@tanstack/react-router";
import { CustomerDisplayPairPage } from "@/components/pos/CustomerDisplayPairPage";

export const Route = createFileRoute("/display/pair")({
  validateSearch: (s: Record<string, unknown>) => ({
    code: typeof s.code === "string" ? s.code : undefined,
  }),
  component: CustomerDisplayPairPage,
});
